import React, { useEffect } from 'react';

import { Button, DatePicker, Drawer, Form, InputNumber, Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { requiredRule } from 'utils/forms/validationRules';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import dayjs from 'dayjs';

function DiscountForm({
  isActive,
  onClose,
  onCreate,
  onUpdate,
  initialValues,
}) {
  const [form] = Form.useForm();
  const isEditing = initialValues !== null;

  useEffect(() => {
    if (initialValues) {
      const { percent, start_at, end_at, is_active } = initialValues;

      form.setFieldsValue({
        percent,
        date: [dayjs(start_at), dayjs(end_at)],
        is_active,
      });
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleSubmit = (values) => {
    const [start, end] = values.date;

    const payload = {
      ...values,
      id: initialValues?.id,
      start_at: start.format('YYYY-MM-DD'),
      end_at: end.format('YYYY-MM-DD'),
    };

    delete payload.date;

    if (isEditing) {
      onUpdate(payload, initialValues.id);
    } else {
      onCreate(payload);
    }

    form.resetFields();
  };

  return (
    <Drawer
      title={isEditing ? 'Редактирование сервиса' : 'Создание сервиса'}
      width="50%"
      onClose={onClose}
      visible={isActive}
      getContainer={false}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
        initialValues={{ is_active: true }}
      >
        <Form.Item name="percent" label="Процент" rules={[requiredRule]}>
          <InputNumber
            addonAfter="%"
            controls={false}
            placeholder="Процент"
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item
          name="date"
          label="Дата действие скидки"
          rules={[requiredRule]}
        >
          <DatePicker.RangePicker
            format="DD.MM.YYYY"
            allowClear
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item label="Статус" name="is_active" valuePropName="checked">
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
          />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit">
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { DiscountForm };
